module.exports = __webpack_public_path__ + "static/media/zheng2-2.03870b6c.png";